import { render, staticRenderFns } from "./ChangeDate.vue?vue&type=template&id=5da565de&scoped=true"
import script from "./ChangeDate.vue?vue&type=script&lang=js"
export * from "./ChangeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da565de",
  null
  
)

export default component.exports